/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isbooked1Inputs */

const en__field_isbooked1 = /** @type {(inputs: _Field_Isbooked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is booked`)
};

const de__field_isbooked1 = /** @type {(inputs: _Field_Isbooked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist gebucht`)
};

/**
* | output |
* | --- |
* | "is booked" |
*
* @param {_Field_Isbooked1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isbooked1 = /** @type {((inputs?: _Field_Isbooked1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isbooked1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isbooked1(inputs)
	return de__field_isbooked1(inputs)
});
export { _field_isbooked1 as "_field_isBooked" }